document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.popup-offer-modal[data-popup-offer]').forEach((modal) => {
    const storageKey = `popup-offer-dismissed-${modal.id}`;
    const frequency = modal.dataset.frequency;
    const delaySeconds = parseInt(modal.dataset.delay, 10) || 0;
    const storage = frequency === 'session' ? sessionStorage : localStorage;

    if (frequency !== 'always') {
      const dismissedAt = storage.getItem(storageKey);
      if (dismissedAt) {
        if (frequency === 'day') {
          const oneDayMs = 24 * 60 * 60 * 1000;
          if (Date.now() - parseInt(dismissedAt, 10) < oneDayMs) return;
        } else {
          return;
        }
      }
    }

    const markDismissed = () => {
      if (frequency !== 'always') storage.setItem(storageKey, Date.now().toString());
    };

    modal.addEventListener('click', (event) => {
      if (event.target === modal) markDismissed();
    });

    const closeButton = modal.querySelector('[id^="ModalClose-"]');
    if (closeButton) closeButton.addEventListener('click', markDismissed);

    modal.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') markDismissed();
    });

    window.setTimeout(() => {
      if (typeof modal.show === 'function') modal.show();
    }, delaySeconds * 1000);
  });
});
